import AssetLimitModal from './AssetLimitModal.container';

export default AssetLimitModal;
